module.exports = __webpack_public_path__ + "static/img/fpdh.9a73cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fpdh.png
// module id = eBSZ
// module chunks = 0